module.exports = __webpack_public_path__ + "img/pc_index11.66453ed5.png";